// dependencies
import React from "react";
import { Link } from "yarrr";
import PropTypes from "prop-types";
import { connect, useSelector } from "react-redux";

// actions
import { clearBadLogins } from "../../actions";

// selectors
import { getCurrentEnvironment } from "../../../../Selectors/app";

// css
import css from "./CustomerControls.styl";

const CustomerControls = (props) => {
	const { customerID } = props;
	const environment = useSelector(getCurrentEnvironment);

	return (
		<div className={css.main}>
			<div>
				<div onClick={() => props.handleClearBadLogins()} className={css.control}>
					Clear Bad Logins
				</div>
				<Link
					isExternal={true}
					href={`https://api.logan.performyard.com/export-breadcrumbs/${environment.name}/${customerID}`}
					className={css.control}
				>
					Export Breadcrumbs to CSV
				</Link>
			</div>
		</div>
	);
};

CustomerControls.propTypes = {
	handleClearBadLogins: PropTypes.func.isRequired,
	customerID: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch, ownProps) => ({
	handleClearBadLogins: () => dispatch(clearBadLogins(ownProps.customerID)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CustomerControls);
